import React, {useState} from "react";
import Results from "../ResultsFolder/Results";
import axios from "axios";
import './Dictionary.css';
import Photos from "../ResultsFolder/Photos";

export default function Dictionary() {
  let [keyword, setKeyword] = useState("");
  let [results, setResults] = useState(null);
  let [images, setImages] = useState(null);

    function handleResponse(response) {
    setResults(response.data);
    }

    function handleImageResponse(response) {
    setImages(response.data.photos);
}

   function search(event) {
    event.preventDefault();

    let apiKey = "141903t193o7f25eb4f8b827eac040ff";
    let apiUrl = `https://api.shecodes.io/dictionary/v1/define?word=${keyword}&key=${apiKey}`;
    axios.get(apiUrl).then(handleResponse);
    
    let imgKey = "141903t193o7f25eb4f8b827eac040ff";
    let imgUrl = `https://api.shecodes.io/images/v1/search?query=${keyword}&key=${imgKey}`;
    axios.get(imgUrl).then(handleImageResponse);
    
   }

  function handleKeywordChange(event) {
    setKeyword(event.target.value);
  }

  return <div className="Dictionary">
    <section>
    <form onSubmit={search}>
      <input type="search" placeholder="Search for a word..." onChange={handleKeywordChange}/>
    
    </form>
    <div className="hint">
      suggested words: sunset, yoga, wine...
    </div>
    
    </section>
    <div className={images?.length ? "SearchResults withPhotos" : "SearchResults"}>
    <Results results={results}/>
    <Photos photos={images} />
    </div>
  </div>;
}